// src/components/Admin/VirtualScenes/SceneList.js
import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { size, map } from "lodash";
import { SceneItems } from "../SceneItems";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks"; 
import "./SceneList.scss";

const virtualSceneController = new VirtualScenes();

export function SceneList({ reload, onReload }) {
  const { accessToken, user } = useAuth();
  const [scenes, setScenes] = useState(null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setNotFound(false);
        const response = await virtualSceneController.getVirtualScenesMiniCreator(
          { page, limit: 12 },
          accessToken
        );
        // Filtramos solo las escenas cuyo userId coincida con el usuario actual
        const filtered = (response.miniatureData || []).filter(
          (scene) => scene.userId === user.user._id
        );
        if (filtered.length === 0) {
          setScenes([]);
          setPagination(null);
          setNotFound(true);
        } else {
          setScenes(filtered);
          setPagination({
            limit: response.limit,
            page: response.currentPage,
            totalPages: response.totalPages,
            totalDocs: filtered.length,
          });
        }
      } catch (error) {
        console.error("Error al cargar las escenas:", error);
        setScenes([]);
        setPagination(null);
        setNotFound(true);
      }
    })();
  }, [page, reload, accessToken, user.user._id]);

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (scenes === null && !notFound) {
    return <Loader active inline="centered" />;
  }

  if (notFound || size(scenes) === 0) {
    return <h2>No existen escenas creadas por ti</h2>;
  }

  return (
    <div className="scene-list-container">
      <div className="list-scenes">
        {map(scenes, (scene) => (
          <SceneItems key={scene.refId} scene={scene} onReload={onReload} />
        ))}
      </div>
      {pagination && (
        <div className="pagination-container">
          <Pagination
            totalPages={pagination.totalPages}
            activePage={pagination.page}
            onPageChange={changePage}
            ellipsisItem={null}
            firstItem={null}
            lastItem={null}
          />
        </div>
      )}
    </div>
  );
}
